import {Component} from "@angular/core";

@Component({
  selector: 'app-voiceotp',
  templateUrl: './voiceotp.component.html'
})
export class VoiceotpComponent {}
